import { Theme } from "@material-ui/core";
import {} from "../../theme";
const styles = (theme: Theme) =>
  ({
    illu: {
      position: "absolute",
    },
    illuGauche: {
      left: 0,
      bottom: 10,
      lineHeight: 0, // make the div fit the svg content, not expand
    },
    illuGaucheHome: {
      left: 0,
      top: 330,
      zIndex: "-1",
    },
    illuDroite: {
      right: 0,
      top: 310,
    },
    illuDroiteHome: {
      top: 120,
      right: 0,
    },
    noHeader: {
      marginTop: 42,
    },
    "@media all and (max-width: 886px)": {
      illuDroiteHome: {
        width: "80px",
      },
      illuGaucheHome: {
        width: "80px",
      },
    },
  } as any);

export default styles;
